import * as React from 'react';

import Backbone, { NavigateOptions } from 'backbone';

export const RouterContext = React.createContext<TeacherRouter>(undefined);

export interface TeacherRouter extends Partial<Backbone.Router> {
  routeToLaunch: () => void;
  routeToEditQuiz: (socNumber: string, quizVersion: number) => void;
  routeToQuizzes: () => void;
  routeToWorkspace: (workspaceId: string) => void;
  routeToTeacherLogin: () => void;
  routeToResults: (activityInstanceId: number) => void;
  routeToResultsQuestion: (
    activityInstanceId: number,
    questionPosition: number,
    shouldReplace?: boolean
  ) => void;
  routeToSpaceRace: (shouldReplace?: boolean) => void;
  navigate(fragment: string, opt: NavigateOptions | boolean): Backbone.Router;
  lastRoute: string;
}

interface RouterProviderProps {
  router: TeacherRouter;
  children: React.ReactNode;
}

export function RouterProvider({ router, children }: RouterProviderProps) {
  return (
    <RouterContext.Provider value={router}>{children}</RouterContext.Provider>
  );
}

export function useSocrativeRouter() {
  const context = React.useContext(RouterContext);
  if (context === undefined) {
    throw new Error('Socrative router is not defined.');
  }
  return context;
}

/**
 * With this you can do `import { teacherRouter } from '~teacher/context/RouterContext'`
 * instead of having to import from the global window object.
 */
export function getTeacherRouter() {
  return window.SOCRATIVE.teacherRouter;
}
